import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-end space-x-3" }
const _hoisted_4 = { href: "/office/create" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_6 = { class: "mt-6 border rounded-lg border-neutral-100" }
const _hoisted_7 = { class: "tabs flex items-center justify-between pl-6 py-6 pr-3.5 border-b border-neutral-100" }
const _hoisted_8 = { class: "flex items-center space-x-4" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "space-y-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_16 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_17 = {
  key: 0,
  class: "px-6 py-6 text-sm text-gray-900"
}
const _hoisted_18 = { class: "max-w-[200px] flex" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "w-6 h-6 bg-[#FEC52E] rounded-full object-cover text-center m-0.5 inline-block" }
const _hoisted_21 = { class: "text-white text-[0.625rem] font-bold leading-6" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_25 = { class: "flex items-center justify-center mx-auto w-max" }
const _hoisted_26 = { class: "w-full px-6 border-t py-7" }

import { onIonViewWillEnter } from "@ionic/vue";
import { ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import SectionTitle from '@/components/partials/SectionTitle.vue';
import ExportButton from '@/components/buttons/ExportButton.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import EditButton from "@/components/buttons/EditButton.vue";
import ViewButton from '@/components/buttons/ViewButton.vue';
import RestoreButton from "@/components/buttons/RestoreButton.vue";
import DeleteButton from '@/components/buttons/DeleteButton.vue';
import DataTable from '@/components/partials/DataTable.vue';
import FilterPanel from '@/components/partials/FilterPanel.vue';
// import MinifyPagination from '@/components/partials/MinifyPagination.vue';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import TabComponent from '@/components/partials/TabComponent.vue';
import DatePicker from "@/components/inputs/DatePicker.vue";
import { PlusIcon } from '@heroicons/vue/24/outline';
import SelectOptions from "@/components/inputs/SelectOptions.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import { hasPermission } from "@/classes/AuthService";

import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import Offices from "@/classes/Offices";
import { SelectInterface } from "@/interfaces/pages/offices/OfficeInterface"

import assignValues from "@/helpers/assignValues"
import PageLoader from "@/components/loaders/PageLoader.vue"

import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

// import { filters, items } from "@/interfaces/pages/FilterPageInterface"; // Removed shared state
import debounce from "lodash/debounce"
import Storage from "@/helpers/storage";
import { RoleTypes } from "../enums/RoleTypes";
import ErrorModal from "@/components/modals/ErrorModal.vue";
import { errorResponse } from "@/helpers/errorMessage";

// Local reactive state for offices component
import BaseIndexFilters from "@/classes/General/BaseIndexFilters";
import BaseIndexItems from "@/classes/General/BaseIndexItems";
import { BasePageInterface, BaseItemsInterface } from "@/interfaces/pages/BasePageInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Local reactive state for offices component (replacing shared state)
const filters = ref<BasePageInterface>(new BaseIndexFilters());
const items = ref<BaseItemsInterface>(new BaseIndexItems());

const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);

const regionOptions = ref<SelectInterface[]>([]);
const provinceOptions = ref<SelectInterface[]>([]);
const cityOptions = ref<SelectInterface[]>([]);
const barangayOptions = ref<SelectInterface[]>([]);


const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const showExportSuccess = ref<boolean>(false);
const isSuperAdmin = ref<boolean>(false)
const selectedId = ref<number|null>(null);
const tabs = ref();
const tokens = new Storage();
const user = JSON.parse(tokens.get("user"));
const showError = ref(false);
const errors = ref<any>();

const headers: { text: string, haveSort?: boolean }[] = [
    { text: 'Prefix' },
    { text: 'Office Name', haveSort: true },
    { text: 'Office Personnel' },
    { text: 'Date Created' },
];

/**
 * METHODS
 */
/**
 * METHODS
 */
const getData = (): void => {
    loading.value = true
    Offices.index(pickBy(filters.value))
        .then(({ data }) => {
            items.value = data.items;
            filters.value = assignValues(filters.value, data);
            
            regionOptions.value = data.region;
            provinceOptions.value = data.province;
            cityOptions.value = data.city;
            barangayOptions.value = data.barangay;
            isSuperAdmin.value = data.isSuperAdmin;

            loading.value = false;

            if (hasPermission('can-view-department')) {
                tabs.value = [
                    {
                        name: "All",
                        count: filters.value.allItemsCount,
                        tab: null,
                        allowed: true,
                    },
                    {
                        name: "Archived",
                        count: 0,
                        tab: "archived",
                        allowed: true,
                    },
                    {
                        name: "Action Logs",
                        count: filters.value.activityLogsCount,
                        tab: "activity_logs",
                        allowed: true,
                    }, 
                ]
            } else {
                tabs.value = [
                    {
                        name: "All",
                        count: filters.value.allItemsCount,
                        tab: null,
                        allowed: true,
                    },
                    {
                        name: "Action Logs",
                        count: filters.value.activityLogsCount,
                        tab: "activity_logs",
                        allowed: true,
                    }, 
                ]
            }
        })
        .catch((error: any) => {
            console.log(error);
            showError.value = false;
            loading.value = false;
            errors.value = errorResponse(error.response?.data?.errors || error.response?.data?.message)
            if (error.response.status == 403) {
                showError.value = true;
            }
        });
};

const applyFilters = (search: any = null) => {
    showFilter.value = false;
    filters.value.search = search;
    getData();
};

const applyReset = () => {
    filters.value.filterDate = null;
    filters.value.filterRegion = null;
    filters.value.filterProvince = null;
    filters.value.filterCity = null;
    filters.value.filterBarangay = null;

    showFilter.value = false;
    getData();

};

const paginate = ({ page, rows }): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })
    
    getData();
};

const updateTab = (currentTab: string) => {
    filters.value.tab = currentTab;
    filters.value.page = 1;
    applyFilters();
};

/**
 * MODALS
 */
const showDeleteModal = (item: any): void => {
    showConfirmation.value = true;
    selectedId.value = item.id;
};

const closeDeleteModal = (): void => {
    showSuccess.value = false;
};

const deleteRecord = (): void => {
    Offices.delete(selectedId.value)
        .then(() => {
            showSuccess.value = true;
            showConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const showRestoreModal = (item: any): void => {
    showRestoreConfirmation.value = true;
    selectedId.value = item.id;
};

const closeRestoreModal = (): void => {
    showRestoreSuccess.value = false;
};

const restoreRecord = (): void => {
    Offices.restore(selectedId.value)
        .then(() => {
            showRestoreSuccess.value = true;
            showRestoreConfirmation.value = false;
            applyFilters();
        })
        .catch((error) => console.log(error));
};

const exportData = (): void => {
    loading.value = true
    Offices.export(filters.value)
        .then(() => {
            loading.value = false
            showExportSuccess.value = true;
        })
        .catch((error) => console.log(error));
};


const closeExport = (): void => {
    showExportSuccess.value = false;
};

const canCreate = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT) {
        return true;
    }

    return false;
}

const canDelete = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT) {
        return true;
    }

    return false;
}

const canRestore = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT) {
        return true;
    }

    return false;
}

/**
 * WATCHERS
 */
watch(
    () => filters.value.search,
    debounce(() => {
        filters.value.page = 1;
        getData();
    }, 1000)
);


watch(
    () => filters.value.filterRegion,
    throttle((value) => {
        filters.value.filterProvince = null
        filters.value.filterCity = null
        filters.value.filterBarangay = null
        getData();
    }, 100)
);
watch(
    () => filters.value.filterProvince,
    throttle((value) => {
        if (value) {
            filters.value.filterCity = null
            getData();
        }
    }, 100)
);
watch(
    () => filters.value.filterCity,
    throttle((value) => {
        if (value) {
            filters.value.filterBarangay = null
            getData();
        }
    }, 100)
);
watch(
    () => filters.value.filterBarangay,
    throttle((value) => {
        if (value) {
            getData();
        }
    }, 100)
);

// onMounted(() => {
//     getData();
// });

onIonViewWillEnter(() => getData());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Office",
            description: "View the relevant in the system."
          }),
          _createElementVNode("div", _hoisted_3, [
            (_unref(hasPermission)('can-view-department'))
              ? (_openBlock(), _createBlock(ExportButton, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (exportData()))
                }))
              : _createCommentVNode("", true),
            _createElementVNode("a", _hoisted_4, [
              (canCreate())
                ? (_openBlock(), _createBlock(ButtonComponent, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(TabComponent, {
                tabs: tabs.value,
                "onUpdate:tab": _cache[1] || (_cache[1] = (value) => updateTab(value))
              }, null, 8, ["tabs"])
            ])
          ]),
          (filters.value.tab != 'activity_logs')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(DataTable, {
                  headers: headers,
                  "no-action": false,
                  count: items.value.total,
                  hasSearch: true,
                  searchPlaceholder: "Search office",
                  tableClass: "header-frm-table",
                  dataTableClass: "border-0",
                  "onUpdate:searchText": _cache[9] || (_cache[9] = (value) => (filters.value.search = value))
                }, {
                  topContent: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (showFilter.value = true))
                      }, _hoisted_12),
                      _createVNode(FilterPanel, {
                        show: showFilter.value,
                        onClose: _cache[7] || (_cache[7] = ($event: any) => (showFilter.value = false)),
                        "onApply:reset": _cache[8] || (_cache[8] = ($event: any) => (applyReset())),
                        "onApply:filters": applyFilters
                      }, {
                        fields: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(DatePicker, {
                              id: "date_created",
                              name: "date_created",
                              label: "Date Created",
                              range: true
                            }),
                            (isSuperAdmin.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(MultiSelect, {
                                    options: regionOptions.value,
                                    label: "Region",
                                    id: "region",
                                    name: "region",
                                    placeholder: "Select..",
                                    searchable: "",
                                    required: "",
                                    modelValue: filters.value.filterRegion,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.filterRegion) = $event))
                                  }, null, 8, ["options", "modelValue"]),
                                  _createVNode(MultiSelect, {
                                    options: provinceOptions.value,
                                    label: "Province",
                                    id: "province",
                                    name: "province",
                                    placeholder: "Select..",
                                    searchable: "",
                                    required: "",
                                    modelValue: filters.value.filterProvince,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.filterProvince) = $event))
                                  }, null, 8, ["options", "modelValue"]),
                                  _createVNode(MultiSelect, {
                                    options: cityOptions.value,
                                    label: "City",
                                    id: "city",
                                    name: "city",
                                    placeholder: "Select..",
                                    searchable: "",
                                    required: "",
                                    modelValue: filters.value.filterCity,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.filterCity) = $event))
                                  }, null, 8, ["options", "modelValue"]),
                                  _createVNode(MultiSelect, {
                                    options: barangayOptions.value,
                                    label: "Barangay",
                                    id: "barangay",
                                    name: "barangay",
                                    placeholder: "Select..",
                                    searchable: "",
                                    required: "",
                                    modelValue: filters.value.filterBarangay,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.filterBarangay) = $event))
                                  }, null, 8, ["options", "modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(" > ")
                        ]),
                        _: 1
                      }, 8, ["show"])
                    ])
                  ]),
                  body: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                      return (_openBlock(), _createElementBlock("tr", { key: item }, [
                        _createElementVNode("td", _hoisted_15, _toDisplayString(item.prefix), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(item?.name), 1),
                        (item.assigned_personnels)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.assigned_personnels[0], (personnel) => {
                                  return (_openBlock(), _createElementBlock("div", { key: personnel }, [
                                    _createElementVNode("img", {
                                      class: "w-6 h-6 bg-[#FEC52E] rounded-full object-cover text-center m-0.5 inline-block",
                                      src: personnel
                                    }, null, 8, _hoisted_19)
                                  ]))
                                }), 128)),
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(item.assigned_personnels[1] || 0), 1)
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("td", _hoisted_22, " - ")),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(item.created_at_formatted), 1),
                        _createElementVNode("td", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            (!filters.value.tab)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_unref(hasPermission)('can-view-admins'))
                                    ? (_openBlock(), _createBlock(ViewButton, {
                                        key: 0,
                                        onClick: ($event: any) => (_unref(router).replace({ path: '/personnel/index', query: { office: item.id } })),
                                        class: "shrink-0"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(EditButton, {
                                    onClick: ($event: any) => (_unref(router).replace(`/office/edit/${item.id}`)),
                                    class: "shrink-0"
                                  }, null, 8, ["onClick"]),
                                  (canDelete())
                                    ? (_openBlock(), _createBlock(DeleteButton, {
                                        key: 1,
                                        onClick: ($event: any) => (showDeleteModal(item)),
                                        class: "shrink-0"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (filters.value.tab == 'archived')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (canRestore())
                                    ? (_openBlock(), _createBlock(RestoreButton, {
                                        key: 0,
                                        onClick: ($event: any) => (showRestoreModal(item)),
                                        class: "shrink-0"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["count"])
              ]))
            : _createCommentVNode("", true),
          (filters.value.tab == 'activity_logs')
            ? (_openBlock(), _createBlock(ActivityLogsTable, {
                key: 1,
                items: items.value
              }, null, 8, ["items"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(SimplePagination, {
              numRows: filters.value.rows,
              currentPage: items.value.current_page,
              "last-page": items.value.last_page,
              onUpdate: _cache[10] || (_cache[10] = (value) => paginate(value))
            }, null, 8, ["numRows", "currentPage", "last-page"])
          ])
        ])
      ]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showConfirmation.value,
        onCancel: _cache[11] || (_cache[11] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[12] || (_cache[12] = ($event: any) => (deleteRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Delete Record",
        content: "Are you sure you wish to delete this Office?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[13] || (_cache[13] = ($event: any) => (closeDeleteModal())),
        "action-text": "Close",
        title: "Record Deleted!",
        content: "Selected office has been successfully deleted!"
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        typeTwo: true,
        show: showRestoreConfirmation.value,
        onCancel: _cache[14] || (_cache[14] = ($event: any) => (showRestoreConfirmation.value = false)),
        onConfirm: _cache[15] || (_cache[15] = ($event: any) => (restoreRecord())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Restore Record",
        content: "Are you sure you wish to restore this office?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showRestoreSuccess.value,
        onConfirm: _cache[16] || (_cache[16] = ($event: any) => (closeRestoreModal())),
        "action-text": "Close",
        title: "Record Restored!",
        content: "Selected office has been successfully office!"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showExportSuccess.value,
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (closeExport())),
        "action-text": "Close",
        title: "Personnels Exported!",
        content: "Please check your email for the exported offices"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        show: showError.value,
        content: errors.value?.message
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }))
}
}

})